import { getSessionVersion, registerSessionCleanup } from "@/shared/lib/auth"
import type { User } from "../model/types"

// Only server answers mark the user: the boot snapshot and setQueryData do not.
const confirmed = new Map<number, { user: User; at: number }>()

export function markUserConfirmed(user: User, sessionVersion: number): void {
	if (sessionVersion !== getSessionVersion()) return
	confirmed.set(user.id, { user, at: Date.now() })
}

export function confirmedUserWithin(userId: number, ms: number): User | null {
	const entry = confirmed.get(userId)
	if (!entry || Date.now() - entry.at >= ms) return null
	return entry.user
}

registerSessionCleanup(() => confirmed.clear())
